/*

  Components

*/

require('./quality-seal-portal/quality-seal-portal-helper');
require('./quality-seal-portal/quality-seal-portal');
require('./quality-seal-portal/quality-seal-portal-validation')
